import { useState, useEffect } from "react";
import { parseJwt } from "../utils/jwt/parseJwt";
import { useAuth } from "../contexts/AuthContext";
import { useLocation } from "react-router-dom";
import { MENU_MAP } from "./MenuData";
import KoreanClock from "./KoreanClock";
import { Button, Menu, useMantineTheme } from "@mantine/core";
import { IconLock, IconLogout, IconUserBitcoin, IconUserBolt, IconUserCircle } from "@tabler/icons-react";
import { useModal } from "../contexts/useModal";
import { PasswordChange } from "./Modal";
import { toast } from "react-toastify";

const Header = () => {
  const [userName, setUserName] = useState("사용자");
  const [title,setTitle] = useState("");
  const { refreshKey } = useAuth();
  const location = useLocation();
  const theme = useMantineTheme();
  const {showModal} = useModal();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const payload = accessToken ? parseJwt(accessToken) : null;
    const userId = payload?.sub || '사용자';
    const _userName = payload?.userName || `UID: ${userId}`;
    setUserName(_userName);
  }, [refreshKey]);

  useEffect(()=>{
    setTitle(MENU_MAP[location.pathname]);
  },[location.pathname]);

  const handleLogout = () =>{
    localStorage.clear();
    window.location.href = "/login";
  }

  const handleChangePassword = async() =>{
    const flag = await showModal({component:PasswordChange,props:{}});
    if(flag){
      toast.success('비밀번호가 변경되었습니다.');
    }
  }

  return (
    <header
      style={{
        height: 60,
        borderBottom: "1px solid #f3f3f3",
        display: "flex",
        alignItems: "center",
        padding: "0 24px",
      }}
    >
      {/*
      <div style={{
        marginRight:"auto"
        ,fontWeight: 700
        ,fontSize: '1.5rem'
      }}>
        {title}
      </div>
      */}
      <KoreanClock />
      <div style={{ marginLeft: "auto" }}>
        <Menu
          transitionProps={{ transition: 'pop-top-right' }}
          position="bottom-end"
          width={180}
          withinPortal
          radius="md"
        >
          <Menu.Target>
            <Button
              leftSection={<IconUserCircle size={18} color={theme.colors.dark[6]} stroke={1.5} />}
              variant="subtle"
              color="dark"
            >{userName}</Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              leftSection={<IconLock size={20} color={theme.colors.blue[6]} stroke={1.5} />}
              onClick={handleChangePassword}
            >비밀번호 변경</Menu.Item>
            <Menu.Item
              leftSection={<IconLogout size={20} color={theme.colors.pink[6]} stroke={1.5} />}
              onClick={handleLogout}
            >로그아웃</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </header>
  );
};

export default Header;
